import 'babel-polyfill'

import Vue from 'vue';
import inViewportDirective from 'vue-in-viewport-directive'
import Vuetify from 'vuetify';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Hammer from 'hammerjs'

// require styles
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)
Vue.use(Vuetify)
Vue.directive('in-viewport', inViewportDirective)

window.Vue = Vue

import '../assets/scss/global/global.scss'

import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'